
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/attrs.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-api-model-attrs-demo-attrs-ref-node","docs-api-model-attrs-demo-attrs-ref-elem","docs-api-model-attrs-demo-attrs-edge-relative-position","docs-api-model-attrs-demo-attrs-edge-subelement-labels"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/attrs.zh.md?type=demo')
};